import { ElementRef, Injectable } from '@angular/core';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import { first } from 'rxjs/operators';

const MAX_QUEUE = 2;

@Injectable()
export class LMFormService {
  private _isFiringInitialValueRule = false;
  private _firingInitialValueRuleCompleted$ = new Subject();
  private _initialValueRuleQueueCounter = 0;

  // Observable sources
  private visibleWhenEventSource = new Subject<ElementRef>();
  private isCreateReportModeSource = new BehaviorSubject<boolean>(false);

  // Observable streams
  visibleWhenEvent$ = this.visibleWhenEventSource.asObservable();
  isCreateReportMode$ = this.isCreateReportModeSource.asObservable();

  constructor() {}

  public waitForFormToBeReady(): Observable<boolean> {
    return new Observable<boolean>(observer => {
      if (this.isFiringInitialValueRule) {
        this.firingInitialValueRuleCompleted
          .pipe(first())
          .subscribe(() => {
            observer.next(true);
            observer.complete();
          });
      } else {
        observer.next(true);
        observer.complete();
      }
    });
  }

  public get firingInitialValueRuleCompleted(): Subject<any> {
    return this._firingInitialValueRuleCompleted$;
  }

  public get isFiringInitialValueRule(): boolean {
    return this._initialValueRuleQueueCounter > 0;
  }

  public set isFiringInitialValueRule(value: boolean) {
    this._isFiringInitialValueRule = value;
  }

  // Service message commands
  visibleWhenEvent(element: ElementRef) {
    this.visibleWhenEventSource.next(element);
  }

  public initialValueRuleQueueCountUp() {
    this._initialValueRuleQueueCounter++;
  }

  public initialValueRuleQueueCountDown() {
    if (this._initialValueRuleQueueCounter > 0) {
      this._initialValueRuleQueueCounter--;
    }
  }

  public get canFireIntialValueRule() {
    return this._initialValueRuleQueueCounter < MAX_QUEUE;
  }

  public getDoesNotExistEmptyMessage(message) {
    return {
      title: message,
      icon: 'icon-empty-no-alerts-new',
    };
  }

  public createReportMode(state: boolean) {
    this.isCreateReportModeSource.next(state);
  }
}
